<template>
  <div :class="$style.wrapper">
    <span>{{ displayValue }}{{ unit }}</span>
    <WfDropdown
      :options="unitOptions"
      :selected-option="unit"
      @selected="handleSelected"
      direction="right"
      :class="{ 'is-disabled': !variable.local }"
    >
      <span>{{ unit }}</span>
      <div>
        <WfIcon icon="caret-down" />
      </div>
    </WfDropdown>
  </div>
</template>

<style lang="scss" module>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}
</style>

<script setup>
import WfIcon from '@/components/WfIcon.vue';
import WfDropdown from '@/components/mainContent/dropdown/WfDropdown.vue';
import { dispatch } from '@/figma/ui-message-handler';
import { computed } from 'vue';

const props = defineProps({
  variable: {
    type: Object,
    required: true,
  },
  mode: {
    type: Object,
    required: true,
  },
});

const unitOptions = ['px', 'em', 'rem'].map((unit) => ({ id: unit, name: unit }));

const displayValue = computed(() => {
  const value = props.mode.value.value;
  return Number.isInteger(value) ? value : Number(value.toPrecision(3));
});

const unit = computed(() => props.mode.value.unit);

const handleSelected = (option) => {
  dispatch('updateWebflowVariableModeUnit', {
    variableId: props.variable.id,
    modeId: props.mode.modeId,
    unit: option.id,
  });
};
</script>
